import webservice from '../../utils/webservice'
const state = {
  session: {
    token: null,
    roles: [],
    payload: null
  },
  carfactoryDealerQuota: []
}

// noinspection JSUnusedGlobalSymbols
const getters = {
  hasRole: ({session}) => role => session.roles.indexOf('ROLE_ROOT') > -1 || session.roles.indexOf(role) > -1
}

const actions = {
  syncCarfactoryDealerQuota ({commit}) {
    return webservice.dealer.findCarfactoryQuota().then(quota => {
      if (quota !== null) {
        commit('setCarfactoryDealerQuota', quota)
      }
    }).catch()
  }
}

// noinspection JSUnusedGlobalSymbols
const mutations = {
  setToken (state, token) {
    state.session.token = token
  },
  setRoles (state, roles) {
    state.session.roles = roles
  },
  setUsername (state, username) {
    state.session.username = username
  },
  setPayload (state, payload) {
    state.session.payload = payload
  },
  setCarfactoryDealerQuota (state, dealerQuota) {
    state.carfactoryDealerQuota = dealerQuota
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js